import { Record } from "../../../fable_modules/fable-library.3.7.20/Types.js";
import { int16_type, record_type, bool_type, uint8_type, string_type, int32_type, option_type, class_type } from "../../../fable_modules/fable-library.3.7.20/Reflection.js";

export class NewInvoicee extends Record {
    constructor(InvoiceeNr, InvoiceeBulkRef, CrossRef, Name, OrganizationNr, Email, ContactPhoneNumber, Street, PostalCode, PostalCity, Country, DistributionCode, IsInbetalningsavi) {
        super();
        this.InvoiceeNr = InvoiceeNr;
        this.InvoiceeBulkRef = InvoiceeBulkRef;
        this.CrossRef = CrossRef;
        this.Name = Name;
        this.OrganizationNr = OrganizationNr;
        this.Email = Email;
        this.ContactPhoneNumber = ContactPhoneNumber;
        this.Street = Street;
        this.PostalCode = PostalCode;
        this.PostalCity = PostalCity;
        this.Country = Country;
        this.DistributionCode = DistributionCode;
        this.IsInbetalningsavi = IsInbetalningsavi;
    }
}

export function NewInvoicee$reflection() {
    return record_type("Containers.FileImport.Details.Model.NewInvoicee", [], NewInvoicee, () => [["InvoiceeNr", option_type(class_type("System.Int64"))], ["InvoiceeBulkRef", option_type(int32_type)], ["CrossRef", option_type(string_type)], ["Name", string_type], ["OrganizationNr", string_type], ["Email", option_type(string_type)], ["ContactPhoneNumber", option_type(string_type)], ["Street", string_type], ["PostalCode", string_type], ["PostalCity", string_type], ["Country", string_type], ["DistributionCode", uint8_type], ["IsInbetalningsavi", bool_type]]);
}

export class NewContract extends Record {
    constructor(InvoiceeNr, InvoiceeBulkRef, ContractBulkRef, ContractTypeCode, ContractCrossReference, EndUser) {
        super();
        this.InvoiceeNr = InvoiceeNr;
        this.InvoiceeBulkRef = InvoiceeBulkRef;
        this.ContractBulkRef = (ContractBulkRef | 0);
        this.ContractTypeCode = ContractTypeCode;
        this.ContractCrossReference = ContractCrossReference;
        this.EndUser = EndUser;
    }
}

export function NewContract$reflection() {
    return record_type("Containers.FileImport.Details.Model.NewContract", [], NewContract, () => [["InvoiceeNr", option_type(class_type("System.Int64"))], ["InvoiceeBulkRef", option_type(int32_type)], ["ContractBulkRef", int32_type], ["ContractTypeCode", string_type], ["ContractCrossReference", option_type(string_type)], ["EndUser", string_type]]);
}

export class NewFee extends Record {
    constructor(FeeBulkRef, ContractNr, ContractBulkRef, Description, Fee, VatRatePercent, StartDate, Period, MonthsInAdvance, AccountNo, BoundToDate, CancellationPeriodMonths, CancelledDate, FeeType) {
        super();
        this.FeeBulkRef = (FeeBulkRef | 0);
        this.ContractNr = ContractNr;
        this.ContractBulkRef = ContractBulkRef;
        this.Description = Description;
        this.Fee = Fee;
        this.VatRatePercent = VatRatePercent;
        this.StartDate = StartDate;
        this.Period = Period;
        this.MonthsInAdvance = (MonthsInAdvance | 0);
        this.AccountNo = (AccountNo | 0);
        this.BoundToDate = BoundToDate;
        this.CancellationPeriodMonths = CancellationPeriodMonths;
        this.CancelledDate = CancelledDate;
        this.FeeType = FeeType;
    }
}

export function NewFee$reflection() {
    return record_type("Containers.FileImport.Details.Model.NewFee", [], NewFee, () => [["FeeBulkRef", int32_type], ["ContractNr", option_type(int32_type)], ["ContractBulkRef", option_type(int32_type)], ["Description", string_type], ["Fee", class_type("System.Decimal")], ["VatRatePercent", class_type("System.Decimal")], ["StartDate", class_type("System.DateOnly")], ["Period", uint8_type], ["MonthsInAdvance", int16_type], ["AccountNo", int32_type], ["BoundToDate", option_type(class_type("System.DateOnly"))], ["CancellationPeriodMonths", uint8_type], ["CancelledDate", option_type(class_type("System.DateOnly"))], ["FeeType", uint8_type]]);
}

export class ConsumptionFee extends Record {
    constructor(RowNr, ContractNr, ContractBulkRef, Description, Volume, ChargePerUnit, ChargeUnit, VatPercentage, Unit, PeriodFrom, PeriodTo, AccountNo, Source, FeeRef) {
        super();
        this.RowNr = (RowNr | 0);
        this.ContractNr = ContractNr;
        this.ContractBulkRef = ContractBulkRef;
        this.Description = Description;
        this.Volume = Volume;
        this.ChargePerUnit = ChargePerUnit;
        this.ChargeUnit = ChargeUnit;
        this.VatPercentage = VatPercentage;
        this.Unit = Unit;
        this.PeriodFrom = PeriodFrom;
        this.PeriodTo = PeriodTo;
        this.AccountNo = (AccountNo | 0);
        this.Source = Source;
        this.FeeRef = FeeRef;
    }
}

export function ConsumptionFee$reflection() {
    return record_type("Containers.FileImport.Details.Model.ConsumptionFee", [], ConsumptionFee, () => [["RowNr", int32_type], ["ContractNr", option_type(int32_type)], ["ContractBulkRef", option_type(int32_type)], ["Description", string_type], ["Volume", class_type("System.Int64")], ["ChargePerUnit", class_type("System.Decimal")], ["ChargeUnit", class_type("System.Int64")], ["VatPercentage", class_type("System.Decimal")], ["Unit", string_type], ["PeriodFrom", option_type(class_type("System.DateOnly"))], ["PeriodTo", option_type(class_type("System.DateOnly"))], ["AccountNo", int32_type], ["Source", string_type], ["FeeRef", option_type(string_type)]]);
}

export class UpdatedInvoicee extends Record {
    constructor(InvoiceeNr, Name, Email, ContactPhoneNumber, DistributionCode, PaymentTermsNetDays, IsInbetalningsavi) {
        super();
        this.InvoiceeNr = InvoiceeNr;
        this.Name = Name;
        this.Email = Email;
        this.ContactPhoneNumber = ContactPhoneNumber;
        this.DistributionCode = DistributionCode;
        this.PaymentTermsNetDays = PaymentTermsNetDays;
        this.IsInbetalningsavi = IsInbetalningsavi;
    }
}

export function UpdatedInvoicee$reflection() {
    return record_type("Containers.FileImport.Details.Model.UpdatedInvoicee", [], UpdatedInvoicee, () => [["InvoiceeNr", class_type("System.Int64")], ["Name", option_type(string_type)], ["Email", option_type(string_type)], ["ContactPhoneNumber", option_type(string_type)], ["DistributionCode", option_type(uint8_type)], ["PaymentTermsNetDays", option_type(uint8_type)], ["IsInbetalningsavi", option_type(bool_type)]]);
}

export class UpdatedContract extends Record {
    constructor(ContractNr, EndUser) {
        super();
        this.ContractNr = (ContractNr | 0);
        this.EndUser = EndUser;
    }
}

export function UpdatedContract$reflection() {
    return record_type("Containers.FileImport.Details.Model.UpdatedContract", [], UpdatedContract, () => [["ContractNr", int32_type], ["EndUser", string_type]]);
}

export class UpdatedFee extends Record {
    constructor(FeeNr, Description, Fee, VatRatePercent, StartDate, Period, MonthsInAdvance, AccountNo, BoundToDate, CancellationPeriodMonths, CancelledDate, FeeType) {
        super();
        this.FeeNr = (FeeNr | 0);
        this.Description = Description;
        this.Fee = Fee;
        this.VatRatePercent = VatRatePercent;
        this.StartDate = StartDate;
        this.Period = Period;
        this.MonthsInAdvance = (MonthsInAdvance | 0);
        this.AccountNo = (AccountNo | 0);
        this.BoundToDate = BoundToDate;
        this.CancellationPeriodMonths = CancellationPeriodMonths;
        this.CancelledDate = CancelledDate;
        this.FeeType = FeeType;
    }
}

export function UpdatedFee$reflection() {
    return record_type("Containers.FileImport.Details.Model.UpdatedFee", [], UpdatedFee, () => [["FeeNr", int32_type], ["Description", string_type], ["Fee", class_type("System.Decimal")], ["VatRatePercent", class_type("System.Decimal")], ["StartDate", class_type("System.DateOnly")], ["Period", uint8_type], ["MonthsInAdvance", int16_type], ["AccountNo", int32_type], ["BoundToDate", option_type(class_type("System.DateOnly"))], ["CancellationPeriodMonths", uint8_type], ["CancelledDate", option_type(class_type("System.DateOnly"))], ["FeeType", uint8_type]]);
}

export class ContractAttribute extends Record {
    constructor(ContractNr, ContractBulkRef, Key, Value) {
        super();
        this.ContractNr = ContractNr;
        this.ContractBulkRef = ContractBulkRef;
        this.Key = Key;
        this.Value = Value;
    }
}

export function ContractAttribute$reflection() {
    return record_type("Containers.FileImport.Details.Model.ContractAttribute", [], ContractAttribute, () => [["ContractNr", option_type(int32_type)], ["ContractBulkRef", option_type(int32_type)], ["Key", string_type], ["Value", string_type]]);
}

export class FeeItemSource extends Record {
    constructor(RowNr, ContractCrossRef, Description, Volume, ChargePerUnit, ChargeUnit, VatPercentage, Unit, PeriodFrom, PeriodTo, Source) {
        super();
        this.RowNr = (RowNr | 0);
        this.ContractCrossRef = ContractCrossRef;
        this.Description = Description;
        this.Volume = Volume;
        this.ChargePerUnit = ChargePerUnit;
        this.ChargeUnit = ChargeUnit;
        this.VatPercentage = VatPercentage;
        this.Unit = Unit;
        this.PeriodFrom = PeriodFrom;
        this.PeriodTo = PeriodTo;
        this.Source = Source;
    }
}

export function FeeItemSource$reflection() {
    return record_type("Containers.FileImport.Details.Model.FeeItemSource", [], FeeItemSource, () => [["RowNr", int32_type], ["ContractCrossRef", string_type], ["Description", string_type], ["Volume", class_type("System.Int64")], ["ChargePerUnit", class_type("System.Decimal")], ["ChargeUnit", class_type("System.Int64")], ["VatPercentage", uint8_type], ["Unit", string_type], ["PeriodFrom", option_type(class_type("System.DateOnly"))], ["PeriodTo", option_type(class_type("System.DateOnly"))], ["Source", string_type]]);
}

export class FeeAttribute extends Record {
    constructor(BulkRef, Key, Value) {
        super();
        this.BulkRef = (BulkRef | 0);
        this.Key = Key;
        this.Value = Value;
    }
}

export function FeeAttribute$reflection() {
    return record_type("Containers.FileImport.Details.Model.FeeAttribute", [], FeeAttribute, () => [["BulkRef", int32_type], ["Key", string_type], ["Value", string_type]]);
}

export class UpdatedAddress extends Record {
    constructor(InvoiceeNr, Attention, Street, PostalCode, PostalCity, Country) {
        super();
        this.InvoiceeNr = InvoiceeNr;
        this.Attention = Attention;
        this.Street = Street;
        this.PostalCode = PostalCode;
        this.PostalCity = PostalCity;
        this.Country = Country;
    }
}

export function UpdatedAddress$reflection() {
    return record_type("Containers.FileImport.Details.Model.UpdatedAddress", [], UpdatedAddress, () => [["InvoiceeNr", class_type("System.Int64")], ["Attention", string_type], ["Street", string_type], ["PostalCode", string_type], ["PostalCity", string_type], ["Country", string_type]]);
}

